import { testIds } from '@/pages/PartnerScore/components/TabSwitcher/TabSwitcher';
import styles from '@/pages/PartnerScore/components/TabSwitcher/TabSwitcher.module.scss';
import { PartnerScoreChannel } from '@/pages/PartnerScore/components/TabSwitcher/utils/types';
import Score, { ScoreProps } from '@/storybook/components/Score/Score';

const getValuePrefix = (id: PartnerScoreChannel, value: number | null | undefined) => {
  return id === PartnerScoreChannel.NPSSCORE && value != null && value > 0 ? '+' : '';
};

export const getChannelTabScore = ({
  id,
  label,
  score,
}: {
  id: PartnerScoreChannel;
  label: string;
  score: Omit<ScoreProps, 'value'> & { value?: number | null };
}) => (
  <div className={styles.coverage} data-testid={testIds.tabSwitcherCoverage(label)}>
    <Score
      value={score.value ?? 0}
      valuePrefix={getValuePrefix(id, score.value)}
      valueSuffix={score.valueSuffix}
      arrowValue={score.arrowValue}
      data-testid={testIds.tabSwitcherValue(label)}
      arrow-testid={testIds.tabSwitcherArrowDirection(label)}
      label-testid={testIds.tabSwitcherCaption(label)}
      displayZero={score.value !== null && score.value !== undefined}
      align="center"
      label={score.label}
      size="SM"
      reverseTitles={score.reverseTitles}
    />
  </div>
);
